import React from 'react';
import LocationSelectorContainer from '../modules/LocationSelector/LocationSelectorContainer';

const LocationsPage = () => <LocationSelectorContainer />;

export default LocationsPage;
